var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"fz-14 yx-color-text-primary yx-pingfang-semibold flex-row flex-align-center flex-just-start"},[_c('i',{staticClass:"status-icon mr-6",class:_vm.curObj.styleClass}),_vm._v(_vm._s(_vm.curObj.cellText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }